import React from 'react';
import { Authenticate } from '../../../Authenticate';
import { AuthField, handleSubmit, handleChange, handleInputErrorsType } from '../../../Authenticate/types';
import { ViewType } from '../../types';
import { AuthPanel, ForgotPassword } from './components';
import { buildReactStateHandler } from '@lib';
import { useAnalytics, Analytics } from '@withjoy/web-core';
interface AuthProps {
  handleBack: (view: ViewType) => void;
}

interface AuthPropsComponent extends AuthProps {
  signUpAnalytics: Analytics;
  loginAnalytics: Analytics;
  forgotPasswordAnalytics: Analytics;
}

export type CurrentForm = 'login' | 'signup' | 'forgotPassword';

interface AuthState {
  currentForm: CurrentForm;
}

const stateHandler = buildReactStateHandler<AuthState>();

class AuthComponent extends React.Component<AuthPropsComponent, AuthState> {
  readonly state: AuthState = {
    currentForm: 'signup'
  };

  componentDidMount() {
    this.props.signUpAnalytics.page.pageEnter();
  }

  handleFormChange = (currentForm: CurrentForm) => {
    const { loginAnalytics, signUpAnalytics, forgotPasswordAnalytics } = this.props;

    const trackMapping = {
      login: loginAnalytics,
      signup: signUpAnalytics,
      forgotPassword: forgotPasswordAnalytics
    };

    if (trackMapping[this.state.currentForm]) {
      trackMapping[this.state.currentForm].page.pageExit();
    }
    if (trackMapping[currentForm]) {
      trackMapping[currentForm].page.pageEnter();
    }

    this.setState(
      stateHandler(draft => {
        draft.currentForm = currentForm;
      })
    );
  };

  render() {
    const { currentForm } = this.state;
    const { signUpAnalytics, loginAnalytics, forgotPasswordAnalytics } = this.props;
    return (
      <Authenticate currentForm={currentForm} loginAnalytics={loginAnalytics} signUpAnalytics={signUpAnalytics}>
        {(
          email: AuthField,
          password: AuthField,
          handleOnChange: handleChange,
          handleSignup: handleSubmit,
          handleLogin: handleSubmit,
          handleOAuth: () => void,
          handleInputErrors: handleInputErrorsType,
          loginError,
          signupError
        ) => {
          const submitFunc = currentForm === 'signup' ? handleSignup : handleLogin;
          const errorType = currentForm === 'signup' ? signupError : loginError;

          if (currentForm === 'forgotPassword') {
            return (
              <ForgotPassword
                forgotPasswordAnalytics={forgotPasswordAnalytics}
                handleFormChange={this.handleFormChange}
              />
            );
          } else {
            return (
              <AuthPanel
                handleOnSubmit={submitFunc}
                handleOnInput={handleOnChange}
                email={email}
                password={password}
                handleOAuth={handleOAuth}
                authType={currentForm}
                error={errorType}
                track={currentForm === 'signup' ? signUpAnalytics.track : loginAnalytics.track}
                handleFormChange={this.handleFormChange}
                handleInputErrors={handleInputErrors}
              />
            );
          }
        }}
      </Authenticate>
    );
  }
}

export const Auth: React.SFC<AuthProps> = ({ ...props }) => {
  const loginAnalytics = useAnalytics({
    pagePrefix: 'marketing',
    category: 'CreateWedding',
    page: 'login',
    deferPageTrack: true
  });

  const signUpAnalytics = useAnalytics({
    pagePrefix: 'marketing',
    category: 'CreateWedding',
    page: 'signup',
    deferPageTrack: true
  });

  const forgotPasswordAnalytics = useAnalytics({
    pagePrefix: 'marketing',
    category: 'CreateWedding',
    page: 'forgotPassword',
    deferPageTrack: true
  });

  return (
    <AuthComponent
      loginAnalytics={loginAnalytics}
      forgotPasswordAnalytics={forgotPasswordAnalytics}
      signUpAnalytics={signUpAnalytics}
      {...props}
    />
  );
};
